// extracted by mini-css-extract-plugin
export var hideLabel = "TeaserButton-module--hideLabel--fcaae";
export var teaserButton = "TeaserButton-module--teaserButton--999ce";